export const priceCalculator = (price, varient, unit, isVarient, qty = 1) => {

  if (unit == 'g' && isVarient) {
    return Number(((varient / 1000) * qty) * price).toFixed(2)
  } else {
    return Number((varient * qty) * price).toFixed(2)
  }

}


export const qtyCalculator = (qty, varient, unit, isVarient) => {
  console.log('qty-calculator-arguments :', qty, varient, unit, isVarient)
  if (unit == 'g' && isVarient) {
    return (varient / 1000) * qty
  } else {
    return varient * qty
  }
}

export const extractWeight = (value) => {

  if (value) {
    let strArr = value?.split(/kg|g|pkt|null/)

    let weight = Number(strArr?.[0])

    // if (value.includes('kg')) {
    //   return weight
    // } else if (value.includes('g')) {
    //   return weight 
    // } else {
    return weight
    // }
  } else {
    return 1
  }

}

export const extractQty = (value) => {

  if (value) {
    let strArr = value.split(" ")

    let qty = Number(strArr?.[strArr?.length - 1])

    return qty
  } else {
    return 1
  }

}